import React from "react";
import { Amplify } from "aws-amplify";
import "aws-amplify/auth/enable-oauth-listener";
import { BrowserRouter } from "react-router-dom";
import { Authenticator, useAuthenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import "./authenticator.css";
import awsExports from "../aws-exports";
import App from "../App";
import {
    CustomHeader,
    CustomFooter,
    HeroPanel,
    CustomSignIn,
    SplashScreen,
} from "./CustomAuthComponents";
import { queryClient } from "../core/query/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { AuthUserBoot, ChatAssistantBoot } from "core";
import { Toaster } from "components/ui/toast";
import { ConfirmProvider } from "components/ui/confirm";
import { ContextComposer } from "core";
Amplify.configure(awsExports);

export default function CustomAuthenticator() {
    function Gate() {
        const { authStatus } = useAuthenticator((c) => [c.authStatus]);

        if (authStatus === "configuring") {
            return <SplashScreen />;
        }

        if (authStatus !== "authenticated") {
            return (
                <div className="merko-auth-shell">
                    <HeroPanel />
                    <div className="merko-auth-right bg-surface">
                        <CustomSignIn />
                    </div>
                    <div style={{ display: 'none', position: 'absolute', pointerEvents: 'none' }}>
                        <Authenticator
                            hideSignUp={process.env.REACT_APP_SIGN_UP === "false"}
                            socialProviders={["google"]}
                            components={{
                                Header: CustomHeader,
                                Footer: CustomFooter,
                            }}
                        />
                    </div>
                </div>
            );
        }

        return (
            <BrowserRouter>
                {/* One notification surface for the whole app. */}
                <Toaster />
                <AuthUserBoot />
                {/* Opens the assistant socket for the whole signed-in session,
                    so §9 broadcasts still arrive while the user is elsewhere. */}
                <ChatAssistantBoot />
                {/* Hosts the single confirmation dialog behind `useConfirm()`,
                    so destructive actions no longer fall back to the OS-native
                    window.confirm(), which ignores the theme and cannot say
                    what is about to be deleted. */}
                <ConfirmProvider>
                    <App />
                </ConfirmProvider>
            </BrowserRouter>
        );
    }

    return (
        <Authenticator.Provider>
            <ContextComposer>
                <QueryClientProvider client={queryClient}>
                    <Gate />
                </QueryClientProvider>
            </ContextComposer>
        </Authenticator.Provider>
    );
}
